/************************************************************
 * Project: Book App
 * Author: Marcos Santos - A01072792
 * BCIT class Comp2913 - ReactJS by Daniel Takeuchi
 * Date: October, 10, 2020.
 * Description: Assignment - Book App
 * https://github.com/maasantos10/
 ************************************************************/

import React, { ButtonHTMLAttributes } from 'react';

import { Container } from './styles';

// type is an interface wihtout subscribed properties.
type ButtonProps = ButtonHTMLAttributes<HTMLButtonElement>;

// children is one of props. - children has the content of button, in this case,
// ...rest has all the rest of props of button attributes
// React.FC already put childern.
const Button: React.FC<ButtonProps> = ({ children, ...rest }) => (
  <Container type="button" {...rest}>
    {children}
  </Container>
);

export default Button;
